export default {
  Users: 'users',
  HealthSystems: 'locations',
  Networks: 'networks',
  Consults: 'consults',
  ConsultRequests: 'consult-requests',
  Providers: 'providers',
  Billing: 'billing',
  Orders: 'orders',
  Hl7Patients: 'hl7-patients',
  ClinicalDecisionSupport: 'clinical-decision-support',
};

export const LocationPaths = {
  Facility: 'facility',
};
